<template>
  <div>
    <p class="mb-5">
      {{ $t('Delivery partners:') }}
    </p>
    <div class="flex flex-wrap gap-4 mb-2.5">
      <ImgView
        v-for="method in DELIVERY_METHODS"
        :key="method.name"
        :src="method.logo"
        :alt="method.name"
        :img-classes="deliveryImgClasses"
      />
    </div>
    <LearnMore :link="deliveryLearnMoreUrl" />
  </div>
</template>

<script lang="ts">

import { DELIVERY_METHODS } from '~~/constants/deliveryMethods';
import { ROUTES } from '~~/constants/routes';

export default defineComponent({
  name: 'DeliveryDetails',

  setup() {

    const { getAdjustedSlug } = useRouteExtended();
    const deliveryLearnMoreUrl = getAdjustedSlug(ROUTES.DISPATCH_INFORMATION);
    const deliveryImgClasses = 'w-11.5 h-7.5 overflow-hidden object-contain';

    return { DELIVERY_METHODS, deliveryLearnMoreUrl, deliveryImgClasses };
  
  },
});

</script>
